import React from 'react';
import {odxIconSets} from "../../constants";

interface OdxPaginatorProps {
    currentPage: number;
    totalPages: number;
    itemCount: number;
    itemsPerPage: number;
    onPageChange: (page: number) => void;
}

/**
 * @param currentPage Current page number
 * @param totalPages Total number of pages
 * @param itemCount Total number of items
 * @param itemsPerPage Number of items per page
 * @param onPageChange Function to call when the page changes
 */

const OdxPaginator: React.FC<OdxPaginatorProps> = ({
                                                       currentPage,
                                                       totalPages,
                                                       itemCount,
                                                       itemsPerPage,
                                                       onPageChange
                                                   }) => {
    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === totalPages;
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, itemCount);

    return (
        <div className="odx-paginator">
            <div className="odx-paginator__summary">
                <span>
                    <strong>{startItem}</strong>&nbsp;
                    to <strong>{endItem}</strong>&nbsp;
                    of <strong>{itemCount}</strong>
                </span>
            </div>
            <div className="odx-paginator__navigation">
                <div className="odx-action-group">
                    <odx-icon-button
                        className="odx-paginator__navigation_first"
                        variant="ghost"
                        icon={`${odxIconSets.core}::chevron-left-end`}
                        onClick={() => onPageChange(1)}
                        disabled={isFirstPage ? true : undefined}
                    />

                    <odx-icon-button
                        className="odx-paginator__navigation_first"
                        variant="ghost"
                        icon={`${odxIconSets.core}::chevron-left`}
                        onClick={() => onPageChange(currentPage - 1)}
                        disabled={isFirstPage ? true : undefined}
                    />
                </div>
                <div className="odx-paginator__range">
                    <span>
                        Page <strong>{currentPage}</strong>&nbsp;
                        of <strong>{totalPages}</strong>
                    </span>
                </div>
                <div className="odx-action-group">
                    <odx-icon-button
                        className="odx-paginator__navigation_first"
                        variant="ghost"
                        icon={`${odxIconSets.core}::chevron-right`}
                        onClick={() => onPageChange(currentPage + 1)}
                        disabled={isLastPage ? true : undefined}
                    />

                    <odx-icon-button
                        className="odx-paginator__navigation_first"
                        variant="ghost"
                        icon={`${odxIconSets.core}::chevron-right-end`}
                        onClick={() => onPageChange(totalPages)}
                        disabled={isLastPage ? true : undefined}
                    />
                </div>
            </div>
        </div>
    );
};

export default OdxPaginator;
